/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertChannelCasing } from 'lib-shared-api-utils';

import { transformConversation } from 'utils/conversation/transformConversation';

import {
  ReadAgentPresenceApiResponse,
  ReadAgentsPresenceApiResponse,
  ReadAgentsPresenceV2ApiResponse,
} from '../types/presenceApi.types';

/**
 * Transforms the read agent presence endpoint response.
 *
 * @param response The raw response.
 */
export function transformReadAgentPresenceResponse(
  response: any,
): ReadAgentPresenceApiResponse {
  transformPresenceChannels(response.data);
  return response;
}

/**
 * Transforms the read agents presence endpoint response.
 *
 * @param response The raw response.
 */
export function transformReadAgentsPresenceResponse({
  data,
  meta,
}: any): ReadAgentsPresenceApiResponse {
  data.forEach(transformPresenceChannels);

  return {
    data: {
      presence_agents: data,
    },
    meta,
  };
}

/**
 * Transforms the read agents presence v2 endpoint response.
 *
 * @param response The raw response.
 */
export function transformReadAgentsPresenceV2Response(
  response: any,
): ReadAgentsPresenceV2ApiResponse {
  response.data.presence.forEach((presenceAgent) => {
    const workloadsByChannel = presenceAgent.workloads_by_channel;
    const nonWorkingChannels = presenceAgent.non_working_channels;

    Object.keys(workloadsByChannel).forEach((conversationChannel) => {
      const value = workloadsByChannel[conversationChannel];
      const snakeCaseConversationChannel = convertChannelCasing(
        conversationChannel,
        'snake',
      );

      delete workloadsByChannel[conversationChannel];
      workloadsByChannel[snakeCaseConversationChannel] = value;
    });

    nonWorkingChannels.map((conversationChannel) =>
      convertChannelCasing(conversationChannel, 'snake'),
    );
  });

  return response;
}

/**
 * Transforms the conversation channel.
 *
 * @param presenceUser The raw presence user from the endpoint response.
 */
function transformPresenceChannels(presenceUser: any): void {
  presenceUser.presence.presence_status.load_descriptions.forEach(
    (loadDescription) => {
      loadDescription.conversation_channel = convertChannelCasing(
        loadDescription.conversation_channel,
        'snake',
      );

      transformConversation(loadDescription.conversation);
    },
  );
}
